import { render } from "./EventParticipationManage.vue?vue&type=template&id=bf9d1888&scoped=true"
import script from "./EventParticipationManage.vue?vue&type=script&lang=js"
export * from "./EventParticipationManage.vue?vue&type=script&lang=js"

import "./EventParticipationManage.vue?vue&type=style&index=0&id=bf9d1888&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf9d1888"]])

export default __exports__